<template>
    <div v-if="loaded || !error" class="preview-image" @click="showMedia()">
        <img :src="previewUrl" alt="thumbnail"/>
    </div>
    <div v-else class="preview-image">
        <img :src="(isThumbnail ? '/storage/thumb/fallback' : '/storage/preview/fallback')" alt="thumbnail"/>
    </div>
</template>


<script>
    import {RELOAD_IMAGE_TIMEOUT} from "./consts";
    const DEBUG = false;

    export default {
        props: ['previewUrl', 'isThumbnail', 'type', 'name', 'showModal'],
        data: function () {
            return {
                loaded: false,
                error: false,
                timeout: null,
                timeoutCount: 0
            }
        },
        watch: {
            element() {
                if(this.timeout) clearTimeout(this.timeout);
                this.timeoutCount = 0;

                this.loadPreview();
            }
        },
        methods: {
            loadPreview() {
                if (this.loaded) return;
                if (!this.previewUrl) return;

                if (DEBUG) console.log(`Loading preview ${this.name}, try number ${this.timeoutCount}`);
                this.timeoutCount++;

                const img = new Image();
                img.src = this.previewUrl;

                img.onload = () => {
                    this.$nextTick(() => {
                        if (DEBUG) console.log(`Loading preview ${this.name} - Success!`);
                        this.loaded = true;
                    });
                }

                img.onerror = () => {
                    if (DEBUG) console.log(`Loading preview ${this.name} - Errored!`);
                    this.error = true;

                    if (this.timeoutCount < RELOAD_IMAGE_TIMEOUT.length) {
                        this.timeout = setTimeout(() => {
                            this.loadPreview();
                        }, RELOAD_IMAGE_TIMEOUT[this.timeoutCount]);
                    }
                }

                this.$forceUpdate();
            },
            showMedia() {
                if (!this.showModal) return;

                let url = this.previewUrl;
                const mime = this.type === 'video' ? 'video/mp4' : 'image/jpg';

                if(this.isThumbnail) {
                    if (this.type === 'video') {
                        url = url + '.jpg';
                    } else if (this.type === 'campaign') {
                        url = url.replace('/thumb', '/original');
                    } else {
                        url = url.replace('/thumb', '');
                    }
                }

                EaseEventBus.fire('showMedia', {
                    mime_type: mime,
                    original: url,
                    display_name: this.name
                });
            },
        },
        mounted() {
            this.loadPreview();
        }
    }
</script>
